export default {
    heading: 'Find a provider',
    description: 'Choose the criteria for your search',
    intro_heading: 'Welcome to MedMatch Network',
    modal_heading: 'Welcome to MedMatch Network! <br />I am a ...',
    modal_button_patient: 'Patient',
    modal_button_provider: 'Provider',
    modal_patient_heading: 'Thank you for visiting MedMatch Network <br />Wait to be redirected to the patient experience:',
}
